import React, { Component } from 'react'

import { findUsername } from '../../api-calls/user'

export default class CreatorName extends Component {

    constructor(props) {
        super(props);
        this.state = {
            username: "finding name..."
        }
    }

    componentDidUpdate() {
        let self = this;
        findUsername(self.props.userId).then((name) => {
            console.log(self.props.userId + "  Name: " + name);
            let newName;
            (name == "" ? newName = self.props.userId : newName = name);
            self.setState({ username: newName });

        });

    }
    render() {
        return (
            <span style={{ fontWeight: '400' }}>
                {this.state.username}
            </span>
        )
    }
}




// let creator = (username == null ? wager.maker : username);


// WEBPACK FOOTER //
// ./src/components/layoutComponents/CreatorName.js